import {Article} from "./article.model";
import {Event} from "./event.model";

export class Content {
  article: Article;
  event: Event;
}
